module.exports = __webpack_public_path__ + "img/05.77a854c8.jpg";